import { Layout } from "../Layout";
import { Seo } from "../../seo/Seo";
import { Contact } from "../Contact";
import { Reveal } from "../Reveal";

export default function ContactPage() {
  return (
    <Layout>
      <Seo path="/contact" />
      <section className="page-hero" data-testid="contact-page-hero">
        <div className="wrap">
          <Reveal>
            <h1 className="page-title" data-testid="contact-page-title">Contact KR Studio</h1>
          </Reveal>
        </div>
      </section>
      <Contact />
    </Layout>
  );
}
